export default __webpack_public_path__ + "static/media/icon-money.fbee60ef.svg";